/**
 * Reformity icon mark — 3-slice arrowhead in cyan / dark / coral.
 * Hand-authored SVG from the brand spec. Paths approximate the supplied logo.
 *
 *   <LogoMark size={36} />          // sized icon
 *   <LogoMark className="h-9 w-9" /> // tailwind sized
 */
const LogoMark = ({
    size,
    className = "",
    title = "Reformity Inc.",
    ...rest
}) => {
    const props = size ? { width: size, height: Math.round(size * 1.4) } : {};
    return (
        <svg
            viewBox="0 0 100 140"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            role="img"
            aria-label={title}
            {...props}
            {...rest}
        >
            <title>{title}</title>
            {/* Left wing — cyan */}
            <path d="M50 0 L10 130 L50 110 Z" fill="#3dbfce" />
            {/* Center wedge — dark; slightly narrower, sits in front */}
            <path d="M50 0 L40 130 L50 110 L60 130 Z" fill="#3d3d3d" />
            {/* Right wing — coral */}
            <path d="M50 0 L90 130 L50 110 Z" fill="#e8564a" />
        </svg>
    );
};

export default LogoMark;
export { LogoMark };
